import Vue from 'vue'
import App from './App.vue'
import router from './router/production'
import store from './store'

import 'polyfill-array-includes';

Vue.config.productionTip = false
// import '../../legacy-style/src/bootstrap/bootstrap-webpack.less'
// import '../../legacy-style/src/main.less'
import 'legacy-style/src/main-style.less'
import  "primevue/resources/primevue.min.css";
// import 'vue-js-modal/dist/styles.css'

//import 'jquery';

// import 'bootstrap/js/dropdown';
// import 'bootstrap/js/dropdown.js';

import i18n from './i18n'
import moment from "moment-timezone";
import {getI18n} from "@/components/legacy/legacy-core";
import {httpAxiosApi} from "capitalist-shared/src/core/axios.errors.handle";
import ToastService from "primevue/toastservice";
import PrimeVue from "primevue/config";
import Toast from "primevue/toast";
import {createApp} from "vue-demi";

// import 'primevue/resources/themes/bootstrap4-light-blue/theme.css';
// import 'primevue/resources/primevue.css';
// import 'primeicons/primeicons.css';
// import 'primeflex/primeflex.css'
// import PrimeVue from 'primevue/config';

// Vue.use(PrimeVue);

moment.tz.setDefault("Europe/Moscow")
Vue.prototype.$http = httpAxiosApi;
// Vue.use(PrimeVue);
Vue.use(ToastService);


const app = createApp({
  router,
  store,
  i18n: getI18n(),
  render: h => h(App),
  components: {
    Toast
  }
})

document.addEventListener('DOMContentLoaded', () => {
  app.mount('#frontofficeAppBlank')
})
